import { Component, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { ApiService, AuthService, CalendarService, ConditionService, DialogService, FieldService, MetadataService, ModalService, TranslatorService } from '../../../services';
import { UscActionPlanComponent } from '../usc-action-plan/usc-action-plan.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'sn-usc-prev-action-plan',
	templateUrl: '../usc-action-plan/usc-action-plan.component.html',
	styleUrls: ['../usc-action-plan/usc-action-plan.component.css']
})
export class UscPrevActionPlanComponent extends UscActionPlanComponent {

	constructor(
		public uscStoreService: UscStoreService,
		public apiService: ApiService,
		public metaDataService: MetadataService,
		public conditionService: ConditionService,
		public fieldService: FieldService,
		public calendarService: CalendarService,
		public translatorService: TranslatorService,
		public dialogService: DialogService,
		public modalService: ModalService,
		public authService: AuthService,
		public ngbModal: NgbModal,
	) {
		super(
			uscStoreService,
			apiService,
			metaDataService,
			conditionService,
			fieldService,
			calendarService,
			translatorService,
			dialogService,
			modalService,
			authService,
			ngbModal
		);
		this.current_view = this.uscStoreService.view_p2w_prev_action_plan;
	}

	ngOnInit() {
		super.ngOnInit();
	}

}




// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-prev-action-plan/usc-prev-action-plan.component.ts